import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "app-button-load-more__content" }


export default /*@__PURE__*/_defineComponent({
  __name: 'AppButtonLoadMore',
  props: {
    loading: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    size: { default: "default" },
    color: { default: "primary" },
    label: { default: "Load more" },
    variant: { default: "text" }
  },
  emits: ["click"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

function handleClick() {
  if (props.disabled || props.loading) return;
  emit("click");
}

return (_ctx: any,_cache: any) => {
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createBlock(_component_v_btn, {
    class: "app-button-load-more",
    variant: __props.variant,
    color: __props.color,
    size: __props.size,
    disabled: __props.disabled || __props.loading,
    onClick: handleClick
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (__props.loading)
          ? (_openBlock(), _createBlock(_component_v_progress_circular, {
              key: 0,
              indeterminate: "",
              size: __props.size === 'small' ? 16 : 18,
              width: 2,
              class: "app-button-load-more__spinner"
            }, null, 8, ["size"]))
          : (_openBlock(), _createBlock(_component_v_icon, {
              key: 1,
              size: "18"
            }, {
              default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                _createTextVNode("mdi-refresh", -1)
              ]))]),
              _: 1
            })),
        _createElementVNode("span", null, _toDisplayString(__props.label), 1)
      ])
    ]),
    _: 1
  }, 8, ["variant", "color", "size", "disabled"]))
}
}

})